export const INITDATA = "INITDATA";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
